import { useTranslation, ConfigProvider } from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 49183, offsets 281616:282427. Structure and names inferred from code, not screenshots.
import { module79457 as dependency79457 } from "../vendor/dependencies.js";
import { module5969 as dependency5969 } from "../vendor/dependencies.js";
import { module11474 as dependency11474 } from "../vendor/dependencies.js";
import * as React from "react";
import { module92363 as l } from "../vendor/dependencies.js";
import { module7781 as s } from "../vendor/dependencies.js";
import * as DateLocaleModule from "./dateLocale.js";
(dependency79457, dependency5969, dependency11474);
let d = (0, React.createContext)(undefined);
function useI18n() {
  let e = (0, React.useContext)(d);
  if (!e) throw Error("useI18n must be used within I18nProvider");
  return e;
}
function I18nProvider({ children: children }) {
  let { i18n: i18n } = useTranslation(),
    [i, u] = (0, React.useState)(i18n.language),
    m = "zh" === i ? l.A : s.A,
    h = (0, React.useMemo)(
      () => ({
        language: i,
        setLanguage: (e) => {
          (i18n.changeLanguage(e),
            u(e),
            (0, DateLocaleModule.setDateLocale)(e),
            localStorage.setItem("user_language_preference", e));
        },
      }),
      [i, i18n],
    );
  return (
    <d.Provider value={h}>
      <ConfigProvider
        locale={m}
        autoInsertSpaceInButton={false}
        wave={{
          disabled: true,
        }}
        theme={{
          token: {
            colorPrimary: "#000000",
            colorPrimaryHover: "#1A1A1A",
            colorPrimaryActive: "#333333",
          },
        }}
      >
        {children}
      </ConfigProvider>
    </d.Provider>
  );
}
export { I18nProvider, useI18n };
